<script lang="ts">
  import ProblemNotice from './ProblemNotice.svelte'
  import { appProblem } from './problems'
  import { t } from './i18n.svelte'
  import { account } from './account.svelte'
  import { friends } from './friends.svelte'
  import { suggestHandle } from './handle'
  import HandleField from './HandleField.svelte'

  /**
   * The one-time step after a first sign-in: choose how friends find you. Both
   * fields arrive filled in (the name from the account, the handle from the
   * name), so the usual path is a single click. Only friends wait on it;
   * sharing and watching never do.
   */
  const start = friends.nameHint || friends.me?.name || ''
  let name = $state(start)
  let handle = $state(suggestHandle(start))
  let ok = $state(false)
  let saving = $state(false)
  let error = $state<string | null>(null)

  async function save(event: SubmitEvent) {
    event.preventDefault()
    if (!ok || saving) return
    saving = true
    error = null
    try {
      await friends.setProfile(name, handle)
    } catch (caught) {
      error = caught instanceof Error ? t(caught.message) : String(caught)
    } finally {
      saving = false
    }
  }
</script>

<div class="setup-backdrop" role="dialog" aria-modal="true" aria-labelledby="setup-title">
  <form class="card stack setup" onsubmit={save}>
    <div>
      <h2 id="setup-title" style="font-size: 1.5rem; letter-spacing: -0.02em">
        {t('Welcome. Pick your handle')}
      </h2>
      <p class="faint" style="margin: 0">
        {t('Friends find you by your handle. You can change both later in Settings.')}
      </p>
    </div>
    <div class="field">
      <label for="setup-name">{t('Display name')}</label>
      <input
        id="setup-name"
        bind:value={name}
        maxlength="32"
        placeholder={t('What should friends call you?')}
        autocomplete="off"
      />
    </div>
    <HandleField bind:value={handle} bind:ok autofix id="setup-handle" />
    {#if error}<ProblemNotice problem={appProblem(error, 'account')} compact />{/if}
    <button class="primary" type="submit" disabled={!ok || saving || name.trim() === ''}>
      {saving ? t('Saving…') : t('Continue')}
    </button>
    <button type="button" class="ghost" onclick={() => account.signOut()}>{t('Sign out')}</button>
  </form>
</div>

<style>
  .setup-backdrop {
    position: fixed;
    inset: 0;
    z-index: 50;
    display: grid;
    place-items: center;
    padding: 16px;
    background: color-mix(in srgb, var(--bg) 78%, transparent);
    backdrop-filter: blur(6px);
  }
  .setup {
    width: min(100%, 420px);
    box-shadow: 0 20px 60px rgb(0 0 0 / 0.18);
  }
</style>
